import { apiClient } from './client';
import type {
  User,
  UserCreateInput,
  UserUpdateInput,
} from '../../types/entities';

export const usersApi = {
  /**
    * Get all users, optionally filtered by tenant slug
    * GET /users?tenant_slug=:slug
    */
  getAll: async (tenantSlug?: string): Promise<User[]> => {
    const query = tenantSlug ? `?tenant_slug=${tenantSlug}` : '';
    return apiClient.get<User[]>(`/users${query}`);
  },

  /**
    * Get a single user by ID
    * GET /users/:id
    */
  getById: async (id: number): Promise<User> => {
    return apiClient.get<User>(`/users/${id}`);
  },

  /**
    * Create a new user
    * POST /users
    */
  create: async (data: UserCreateInput): Promise<User> => {
    return apiClient.post<User>('/users', data);
  },

  /**
    * Update a user
    * PUT /users/:id
    */
  update: async (id: number, data: UserUpdateInput): Promise<User> => {
    return apiClient.put<User>(`/users/${id}`, data);
  },

  /**
    * Delete a user
    * DELETE /users/:id
    */
  delete: async (id: number): Promise<void> => {
    return apiClient.delete<void>(`/users/${id}`);
  },
};
